import { useState } from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

/** ImageGallery — main image + thumbnail strip. Handles both `photos: []` and legacy single URL. */
export default function ImageGallery({ images = [], fallback, alt = "" }) {
  const list = images && images.length ? images : (fallback ? [fallback] : []);
  const [idx, setIdx] = useState(0);
  const cur = list[Math.min(idx, list.length - 1)] || null;

  if (!cur) return null;

  const prev = () => setIdx((i) => (i - 1 + list.length) % list.length);
  const next = () => setIdx((i) => (i + 1) % list.length);

  return (
    <div className="relative w-full h-full">
      <img src={cur} alt={alt} className="w-full h-full object-cover" />
      {list.length > 1 && (
        <>
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); prev(); }}
            className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-[#F9F6F0]/85 text-[#1C1B1A] flex items-center justify-center hover:bg-[#F9F6F0]"
            style={{ transition: "background-color 180ms ease-out" }}
            aria-label="Previous photo"
          >
            <CaretLeft size={14} weight="bold" />
          </button>
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); next(); }}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-[#F9F6F0]/85 text-[#1C1B1A] flex items-center justify-center hover:bg-[#F9F6F0]"
            style={{ transition: "background-color 180ms ease-out" }}
            aria-label="Next photo"
          >
            <CaretRight size={14} weight="bold" />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5">
            {list.map((_, i) => (
              <span
                key={i}
                className="w-1.5 h-1.5 rounded-full"
                style={{ background: i === idx ? "#F9F6F0" : "rgba(249,246,240,0.5)" }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
